export enum PayrollTimecardFeatureFlags {
    DisplayLocumPayrollEffectiveDatesHistory = 'nova-display-locum-payroll-effective-dates-history',
    RevertEffectiveDateHistoryFix = 'revert-effective-date-history-fix',
    CreateEffectiveDateForLocumsW2NonMargin = 'create-effective-dates-for-locum-w2-non-margin',
    LocumsAutoPopulatingEffectiveDateRates = 'locums-auto-populating-effective-date-rates',
    ColoradoWeeklyDailyOvertime = 'colorado-weekly-daily-overtime',
    ShowTimeCardNavigationPreviousNext = 'show-timecard-navigation-previous-next',
    OtherPaymentsExcludeFromBilling = 'other-payments-exclude-from-billing',
    ResyncImportBatchSelfService = 'resync-import-batch-self-service',
    GenerateWorkdayPayrollExportFile = 'generate-workday-payroll-export-file',
    GenerateADPPayrollExportFile = 'generate-adp-payroll-export-for-locums1099',
    DailyTimekeeping = 'daily-timekeeping',
    CopyDailyTimekeepingFacilityProfileSetting = 'copy-daily-timekeeping-facility-profile-setting',
    DisplayOverlappingTimecardsForAWorkweek = 'display-overlapping-timecards-for-a-workweek',
    ShowDisplaySecondsToggleButton = 'show-display-seconds-toggle-button',
    DisableExportPayrollFileForFutureWorkWeeks = 'disable-export-payroll-file-for-future-work-weeks'

}
